import Media from "@/components/Media.vue";

export const mediaInit = {
    component: Media,
    name: "Media",
    inputs: [
        {
            name: "media",
            friendlyName: "Media",
            allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
            type: "file",
            defaultValue: ""
        },
        {
            name: "alt",
            friendlyName: "Alt Text",
            type: "string",
            defaultValue: ""
        },
        {
            name: "defaultMediaType",
            friendlyName: "Media Type",
            type: "string",
            enum: ["image", "video"],
            defaultValue: "image"
        }
    ]
};
